module.exports = __webpack_public_path__ + "static/media/Bahrain.a036cfcd.jpg";